import React from 'react';
import { Layout } from 'antd';
import Login from '../components/Auth/Login';

const LoginPage = () => {
  return (
    <Layout
      style={{
        minHeight: '100vh',
        background: 'transparent',
      }}
    >
      <Login />
    </Layout>
  );
};

export default LoginPage;
